import { Interface } from '@/shared/di/interface'
import { IAssets } from '@/shared/di/interface/assets'
import Pool from '@/shared/misc/pool'
import gsap from 'gsap'

import { IcosahedronGeometry, Mesh, RawShaderMaterial, ShaderMaterial } from 'three'
import { container } from 'tsyringe'
import bubbleMaterial from '../materials/bubble-material'

const bubbleGeo = new IcosahedronGeometry(1.2, 3)
bubbleGeo.translate(0, -0.5, 0)

const imageHeight = 1024
const maxMip = Math.log2(imageHeight) - 2
const texelHeight = 1.0 / imageHeight
const texelWidth = 1.0 / (3 * Math.max(256, 16 * 7))

export class Bubble extends Mesh {
  constructor() {
    super(bubbleGeo, bubbleMaterial.getMaterial())
    this.userData.enableBloom = false

    const assets = container.resolve<IAssets>(Interface.IAssets)

    const mat = this.material as ShaderMaterial
    mat.uniforms.envMap.value = assets.getTexture('envMap')
    mat.depthTest = true
    mat.depthWrite = false
    mat.uniforms.maxMip.value = maxMip
    mat.uniforms.texelHeight.value = texelHeight
    mat.uniforms.texelWidth.value = texelWidth
    mat.uniforms.fresnelIntensity.value = 1
    mat.wireframe = false
  }

  static reset(scope: Bubble) {
    scope.scale.setScalar(1)
    scope.position.set(0, 0, 0)
    scope.rotation.set(0, 0, 0)

    gsap.killTweensOf(scope.scale)
    gsap.killTweensOf(scope.position)
    gsap.killTweensOf(scope.rotation)

    const mat = scope.material as RawShaderMaterial
    if (mat) {
      mat.uniforms.fresnelIntensity.value = 0.6
    }

    while (scope.children.length > 0) {
      scope.remove(scope.children[0])
    }
  }
}
const bubblePool = new Pool(Bubble)

export default bubblePool
